import React from 'react';
import PropTypes from 'prop-types';

/**
 * anchor renderer for MarkdownContent: authored links always open in a new tab.
 * react-markdown passes the mdast `node` along with the html props, and it must
 * not reach the DOM.
 * @param href - link target
 * @param children - link text
 */
export default function MarkdownLink({ href, children, ...rest }) {
  const anchorProps = { ...rest };
  delete anchorProps.node;

  return (
    <a href={href} target='_blank' rel='noopener noreferrer' {...anchorProps}>
      {children}
    </a>
  );
}

MarkdownLink.propTypes = {
  href: PropTypes.string,
  children: PropTypes.node
};
